(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lpm-demo-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{const root=document.querySelector('.lpm-editorial');if(!root)return;const mainImage=root.querySelector('#LpmMainImage');root.querySelectorAll('.lpm-thumb').forEach(thumb=>thumb.addEventListener('click',()=>{if(mainImage)mainImage.src=thumb.dataset.image;root.querySelectorAll('.lpm-thumb').forEach(item=>item.classList.remove('is-active'));thumb.classList.add('is-active')}));const form=root.querySelector('#LpmProductForm');const quantity=root.querySelector('#LpmQuantity');const addButton=root.querySelector('#LpmAddButton');root.querySelectorAll('input[name="lpm_offer"]').forEach(input=>input.addEventListener('change',()=>{root.querySelectorAll('.lpm-offer').forEach(offer=>offer.classList.remove('is-active'));input.closest('.lpm-offer').classList.add('is-active');if(quantity)quantity.value=input.value;const price=input.value==='2'?root.dataset.doublePrice:root.dataset.singlePrice;if(addButton)addButton.textContent=input.value==='2'?`Add bundle to cart — ${price}`:`Add to cart — ${price}`}));const variantInput=root.querySelector('#LpmVariantId');const colorName=root.querySelector('#LpmColorName');root.querySelectorAll('.lpm-swatch').forEach(swatch=>swatch.addEventListener('click',()=>{if(variantInput)variantInput.value=swatch.dataset.variantId;if(colorName)colorName.textContent=swatch.dataset.variantTitle;root.querySelectorAll('.lpm-swatch').forEach(item=>item.classList.remove('is-active'));swatch.classList.add('is-active')}));if(form)form.addEventListener('submit',async event=>{if(!quantity||quantity.value!=='2')return;event.preventDefault();addButton.disabled=true;addButton.textContent='Adding your bundle…';try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantInput.value),quantity:2}]})});if(!response.ok)throw new Error('Unable to add bundle');window.location.href='/discount/2KITSAVE?redirect=/cart'}catch(error){addButton.disabled=false;addButton.textContent='Try adding the bundle again'}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
